const getDefaultState = () => ({
  domains: {
    items: [],
    loading: false,
    error: false,
  },
  templates: {
    items: [],
    loading: false,
    error: false,
    noContent: false,
  },
  save: {
    loading: false,
    error: false,
  },
  domain: undefined,
});

export default getDefaultState;



// WEBPACK FOOTER //
// ./src/store/modules/giftVoucherTemplates/defaultState.js